import styled, { createGlobalStyle } from 'styled-components';

export const ReportingHoverStyle = createGlobalStyle`
  .reporting-modal .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell,
  .reporting-modal .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell * {
    color: #ffffff !important;
  }
`;

export const AddttionalInfoContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    color: #ff6f61;
    font-style: italic;
    font-weight: bold;
  }
`;
